import axios from 'axios';
import { checkoutAction } from './CheckoutSlice';

const getCheckoutData = (token, plan, period, currency) => {
  return async (dispatch) => {
    const fetchData = async () => {
      const url = `${process.env.REACT_APP_DEV_URI}/user/subscription/web/checkout`;
      const headers = { Authorization: `Bearer ${token}` };
      const response = await axios.post(url, { plan, period, currency }, { headers });
      return response;
    };
    try {
      const result = await fetchData();
      dispatch(checkoutAction.checkoutSuccess(result.data));
    } catch (e) {
      dispatch(checkoutAction.checkoutFailure(e.response?.data ?? e.message));
    }
  };
};

export default getCheckoutData;